import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendCreditCardFormLinkEmail = async ({
  callerId,
  emailAddress,
  plan,
}: {
  callerId: string;
  emailAddress?: string;
  plan?: string | null;
}) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      emailAddress,
      plan,
    },
    mutation: graphql(`
      mutation SendCreditCardFormLinkEmail($callerId: String!, $emailAddress: String, $plan: String) {
        sendCreditCardFormLinkEmail(callerId: $callerId, emailAddress: $emailAddress, plan: $plan)
      }
    `),
  });

  return response.data?.sendCreditCardFormLinkEmail ?? false;
};
